import React, { useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';
import { Info, ExpandMore, ExpandLess } from '@mui/icons-material';
import styles from './AllergyInfoTooltip.module.scss';

const AllergyInfoTooltip = ({ themeColors }) => {
  const { checkoutCardsBgColor, checkoutFontColor } = themeColors || {};
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box className={styles.allergyTooltipContainer}>
      <Box 
        className={styles.allergyTooltipCard}
        sx={{
          backgroundColor: checkoutCardsBgColor ?? '#FFF',
          color: checkoutFontColor ?? '#000'
        }}
      >
        <Box 
          className={styles.allergyTooltipHeader}
          onClick={toggleExpanded}
          sx={{ cursor: 'pointer' }}
        >
          <Info className={styles.allergyInfoIcon} />
          <Typography variant="subtitle2" className={styles.allergyTooltipTitle}>
            Allergy Information
          </Typography>
          <Box className={styles.expandIcon}>
            {isExpanded ? (
              <ExpandLess className={styles.chevronIcon} />
            ) : (
              <ExpandMore className={styles.chevronIcon} />
            )}
          </Box>
        </Box>
        
        <Collapse in={isExpanded} timeout={300}>
          <Typography variant="body2" className={styles.allergyTooltipText}>
            <strong>Allergies:</strong> If you, or someone you are ordering for, have a food allergy or intolerance, please contact the restaurant directly before placing your order to inform them.
          </Typography>
        </Collapse>
      </Box>
    </Box>
  );
};

export default AllergyInfoTooltip;
